<section class="mt-5 mb-5" id="gallery">
    <my-portal-inner-load *ngIf="load"></my-portal-inner-load>
    <div *ngIf="!load">
        <my-portal-highlighter [module]="{title: galleryName, description: galleryDescription}"></my-portal-highlighter>
        <div class="mt-3">
            <my-portal-galery-modal [limitImages]="limitImages" [galleryItem]="galleryItem"></my-portal-galery-modal>
        </div>
    </div>
</section>
